<template>
  <div class="oa-page">
    <div class="oa-top">
      <div class="oa-account">账号: {{ displayAccount }}</div>
      <div class="oa-top-actions">
        <button type="button" class="oa-pill oa-pill--ghost" @click="showRules = true">系统公告</button>
        <button type="button" class="oa-pill oa-pill--blue" @click="onContact">联系客服</button>
      </div>
    </div>

    <div class="oa-card">
      <div class="oa-tabs">
        <button
          type="button"
          class="oa-tab"
          :class="{ 'oa-tab--active': tab === 'login' }"
          @click="tab = 'login'"
        >登录</button>
        <button
          type="button"
          class="oa-tab"
          :class="{ 'oa-tab--active': tab === 'register' }"
          @click="tab = 'register'"
        >注册</button>
      </div>

      <div class="oa-form">
        <div class="oa-field">
          <label class="oa-label">账号</label>
          <input
            v-model="username"
            class="oa-input"
            type="text"
            autocomplete="username"
            placeholder="4-32位字母数字下划线, 可带@"
          />
        </div>

        <div class="oa-field">
          <label class="oa-label">密码</label>
          <input
            v-model="password"
            class="oa-input"
            type="password"
            autocomplete="current-password"
            :placeholder="tab === 'login' ? '请输入密码' : '至少6位'"
          />
        </div>

        <div v-if="tab === 'register'" class="oa-field">
          <label class="oa-label">确认密码</label>
          <input
            v-model="confirmPassword"
            class="oa-input"
            type="password"
            autocomplete="new-password"
            placeholder="再次输入密码"
          />
        </div>

        <p v-if="errorMsg" class="oa-error">{{ errorMsg }}</p>
        <p v-if="successMsg" class="oa-success">{{ successMsg }}</p>

        <button
          type="button"
          class="oa-submit"
          :disabled="submitting"
          @click="onSubmit"
        >
          {{ tab === 'login' ? '登录' : '注册并登录' }}
        </button>
      </div>
    </div>

    <div v-if="showRules" class="oa-mask" @click.self="showRules = false">
      <div class="oa-modal">
        <div class="oa-modal-head">规则公告</div>
        <div class="oa-modal-body">
          <p>本平台纯BC菠菜料，绝无假料，本产品对接BC平台充值订单分配。</p>
          <p>
            1.本平台支持：【数字RMB钱包编码】【支付宝账号】【支付宝官方收款码】【支付宝UID】【微信收款码】【银行卡卡号】
          </p>
          <p>
            2.本平台有法律保障7天，若料号被冻结，冻结金额1000RMB以下自行承担，超过10000RMB以上平台承担一半责任（被冻账号报警报案并提供相关证明，审核通过后理赔）。
          </p>
          <p>
            3.禁止恶意抢单、收款后不确认订单等行为，一经核实永久冻结账号并追责。
          </p>
          <p>
            4.系统仅支持USDT充值，到账自动到账；个人申请退款收取2%系统手续费。
          </p>
        </div>
        <div class="oa-modal-foot">
          <button type="button" class="oa-modal-close" @click="showRules = false">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderAuthLogin, orderAuthRegister } from '../util/api';
import { buildReferralQuery, resolveReferralContext } from '../util/deeplink';

const ACCOUNT_KEY = 'order_auth_account';
const USERNAME_RE = /^[A-Za-z0-9_@]{4,32}$/;

export default {
  name: 'OrderAuth',
  data() {
    return {
      tab: 'login',
      username: '',
      password: '',
      confirmPassword: '',
      errorMsg: '',
      successMsg: '',
      submitting: false,
      showRules: false,
      loggedAccount: localStorage.getItem(ACCOUNT_KEY) || '',
      referralCode: '',
      gameGroupId: '',
    };
  },
  computed: {
    displayAccount() {
      return this.loggedAccount || '未登录';
    },
  },
  watch: {
    tab() {
      this.errorMsg = '';
      this.successMsg = '';
      this.password = '';
      this.confirmPassword = '';
    },
  },
  created() {
    // 入口如 /orderAuth?code=Joomthf2np8&gid=-5424252204
    const ctx = resolveReferralContext(this.$route);
    this.referralCode = ctx.referralCode;
    this.gameGroupId = ctx.gameGroupId;
  },
  methods: {
    hallRoute() {
      return {
        path: '/orderHall',
        query: buildReferralQuery(this.referralCode, this.gameGroupId),
      };
    },
    onContact() {
      this.errorMsg = '';
      this.successMsg = '请联系管理员获取客服方式';
    },
    validate() {
      const name = this.username.trim();
      if (!USERNAME_RE.test(name)) {
        this.errorMsg = '账号需为4-32位字母数字下划线，可带@';
        return false;
      }
      if (!this.password) {
        this.errorMsg = '请输入密码';
        return false;
      }
      if (this.tab === 'register') {
        if (this.password.length < 6) {
          this.errorMsg = '密码至少6位';
          return false;
        }
        if (this.password !== this.confirmPassword) {
          this.errorMsg = '两次密码不一致';
          return false;
        }
      }
      return true;
    },
    async onSubmit() {
      this.errorMsg = '';
      this.successMsg = '';
      if (!this.validate()) return;

      this.submitting = true;
      try {
        const payload = {
          username: this.username.trim(),
          password: this.password,
        };
        const res = this.tab === 'login'
          ? await orderAuthLogin(payload)
          : await orderAuthRegister(payload);

        if (res?.code !== 0 && !res?.success) {
          this.errorMsg = res?.message || '操作失败';
          return;
        }

        const account = res?.data?.username || payload.username;
        localStorage.setItem(ACCOUNT_KEY, account);
        this.loggedAccount = account;
        this.successMsg = this.tab === 'login' ? '登录成功' : '注册并登录成功';
        this.password = '';
        this.confirmPassword = '';
        this.$router.push(this.hallRoute());
        return;
      } catch (e) {
        this.errorMsg = e?.response?.data?.message || e?.message || '网络异常，请稍后重试';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.oa-page {
  min-height: 100vh;
  background: #f2f2f2;
  padding: 18px 16px 40px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.oa-top {
  max-width: 560px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.oa-account {
  font-size: 18px;
  font-weight: 800;
  color: #111;
  white-space: nowrap;
}

.oa-top-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.oa-pill {
  height: 36px;
  padding: 0 16px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
}

.oa-pill--ghost {
  background: #fff;
  color: #111;
  border-color: #d0d0d0;
}

.oa-pill--blue {
  background: #3b82f6;
  color: #fff;
  border-color: #3b82f6;
}

.oa-card {
  max-width: 560px;
  margin: 0 auto;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.oa-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.oa-tab {
  height: 56px;
  border: 0;
  font-size: 22px;
  font-weight: 800;
  cursor: pointer;
  background: #ebebeb;
  color: #222;
}

.oa-tab--active {
  background: #111;
  color: #ffcc00;
}

.oa-form {
  padding: 28px 28px 32px;
}

.oa-field {
  margin-bottom: 22px;
}

.oa-label {
  display: block;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #666;
}

.oa-input {
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  border: 2px solid #222;
  border-radius: 14px;
  padding: 0 16px;
  font-size: 15px;
  color: #222;
  background: #fff;
  outline: none;
}

.oa-input::placeholder {
  color: #b0b0b0;
}

.oa-submit {
  width: 100%;
  height: 54px;
  margin-top: 8px;
  border: 0;
  border-radius: 14px;
  background: #ffcc00;
  color: #111;
  font-size: 22px;
  font-weight: 800;
  cursor: pointer;
}

.oa-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.oa-error {
  margin: 0 0 12px;
  color: #e53935;
  font-weight: 700;
  font-size: 14px;
}

.oa-success {
  margin: 0 0 12px;
  color: #1b8e4c;
  font-weight: 700;
  font-size: 14px;
}

.oa-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 1000;
}

.oa-modal {
  width: min(520px, 94vw);
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.28);
}

.oa-modal-head {
  background: #ffcc00;
  text-align: center;
  font-size: 28px;
  font-weight: 900;
  color: #111;
  padding: 16px 12px;
}

.oa-modal-body {
  padding: 18px 20px 8px;
  color: #222;
  font-size: 15px;
  line-height: 1.75;
  font-weight: 600;
  max-height: 55vh;
  overflow-y: auto;
}

.oa-modal-body p {
  margin: 0 0 14px;
}

.oa-modal-foot {
  padding: 8px 20px 20px;
}

.oa-modal-close {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 12px;
  background: #ffcc00;
  color: #111;
  font-size: 20px;
  font-weight: 900;
  cursor: pointer;
}

@media (max-width: 520px) {
  .oa-account {
    font-size: 15px;
  }
  .oa-pill {
    height: 32px;
    padding: 0 12px;
    font-size: 13px;
  }
  .oa-form {
    padding: 22px 18px 26px;
  }
  .oa-tab {
    height: 48px;
    font-size: 18px;
  }
  .oa-modal-head {
    font-size: 22px;
  }
}
</style>
